import { queryOptions } from '@tanstack/react-query';
import { fetchRoleplayDetail } from './roleplays.ts';

/** One practice conversation as its author edits it, for the route loader and the editor alike. */
export function roleplayDetailQuery(roleplayId: string) {
  return queryOptions({
    queryKey: ['roleplay', roleplayId],
    queryFn: () => fetchRoleplayDetail(roleplayId),
  });
}
